// Component: Accordion
// Author: Tejaswini
import AccordionNPM from '@rotaryintl/harris-accordion';
import { Text, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { useState } from 'react';

const Accordion = (props) => {
  const [activeId, setActiveId] = useState(null);

  const handleToggle = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const AccordionData = props.fields?.children?.map((items, index) => {
    return {
      key: index,
      id: items?.fields?.ComponentId,
      active: activeId === items?.fields?.ComponentId,
      handleToggle: () => handleToggle(items?.fields?.ComponentId),
      title: <Text field={items?.fields?.Title} />,
      subTitle: <Text field={items?.fields?.Subtitle} />,
      text: <RichText field={items?.fields?.Text} />,
      disabled: items?.fields?.IsDisabled?.value,
    };
  });

  return (
    <>
      <AccordionNPM items={AccordionData} />
    </>
  );
};

export default withSitecoreContext()(Accordion);
